import type { Story } from './types';
import { MAX_SAVED_STORIES } from './constants';

const STORAGE_KEY = 'storyseed_stories';

export function getSavedStories(): Story[] {
  if (typeof window === 'undefined') return [];
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveStory(story: Story): { success: boolean; message?: string } {
  const stories = getSavedStories();

  if (stories.length >= MAX_SAVED_STORIES) {
    return {
      success: false,
      message: `You can only save ${MAX_SAVED_STORIES} stories. Please delete one first.`,
    };
  }

  if (stories.some((s) => s.id === story.id)) {
    return { success: true };
  }

  stories.unshift(story);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stories));
  return { success: true };
}

export function deleteStory(id: string): void {
  const stories = getSavedStories();
  const filtered = stories.filter((s) => s.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
}

export function getStoryById(id: string): Story | undefined {
  const stories = getSavedStories();
  return stories.find((s) => s.id === id);
}
